export default "__VITE_ASSET__ii40H6l$__"